(function () {
    'use strict';

    /*
     UserAddressAddController
    -------------------------------------------------------------------------- */

    angular
        .module('UserApp.address', [])
        .controller('UserAddressAddController', [
            '$scope',
            '__Form',
            '$state',
            'appServices',
            '__Utils',
            '$rootScope',
            UserAddressAddController
        ]);

    /**
      * UserAddressAddController handle address form & send request to server
      * to submit form data. 
      *
      * @inject $scope
      * @inject __Form
      * @inject $state
      * @inject appServices
      * @inject __Utils
      * 
      * @return void
      *-------------------------------------------------------- */

    function UserAddressAddController($scope, __Form, $state, appServices, __Utils, $rootScope) {

        var scope = this;

        scope = __Form.setup(scope, 'user_address_form', 'userData', {
            secured: false
        });

        scope.addressType = __globals.getAppJSItem('configGetAddressType');

        // Get countries
        scope.countriesCollection = __globals.getAppJSItem('countries');
        scope.countries = scope.countriesCollection.data.countries;

        scope.countries_select_config = __globals.getSelectizeOptions({
            valueField: 'value',
            labelField: 'text',
            searchField: ['text']
        });

        //scope.countries = __globals.configItem('countries');

        /**
          * Submit address form action
          *
          * @return void
          *---------------------------------------------------------------- */

        scope.submit = function () {

            __Form.process('user.address.process', scope)
                .success(function (responseData) {
                    appServices.processResponse(responseData, null, function () {
                        $scope.closeThisDialog({ address_added: true, selectedAddressID: $scope.ngDialogData.selectedAddressID, addressType: $scope.ngDialogData.addressType })
                    });
                });

        };

        /**
         * Close dialog and return promise object
         *
         * @return void
         *---------------------------------------------------------------- */

        scope.close = function () {

            $scope.closeThisDialog({ address_added: true, selectedAddressID: $scope.ngDialogData.selectedAddressID, addressType: $scope.ngDialogData.addressType });
        }

    };

})();